import * as types from './actionTypes';

export const getMerchantList = (payload) => ({
  type: types.GET_MERCHANT_LIST,
  payload,
});

export const setMerchantList = (payload) => ({
  type: types.SET_MERCHANT_LIST,
  payload,
});

export const getMerchantDetails = (payload) => ({
  type: types.GET_MERCHANT_DETAILS,
  payload,
});

export const setMerchantDetails = (payload) => ({
  type: types.SET_MERCHANT_DETAILS,
  payload,
});

export const clearMerchantView = () => ({
  type: types.CLEAR_MERCHANT_VIEW,
});

export const updateMerchantStatus = (payload) => ({
  type: types.UPDATE_MERCHANT_STATUS,
  payload,
});

export const resendApprovedNotificationToMerchant = (merchantId) => ({
  type: types.RESEND_APPROVED_NOTIFICATION_TO_MERCHANT,
  payload: { merchantId },
});
